import { useQuery } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

type StoredToken = {
  AccessToken?: string;
};

export type SeonCooldownResponse = {
  cooldown_active: boolean;
  cooldown_until: number | null;
  remaining_seconds: number;
  has_active_challenge: boolean;
} | null;

const fetchSeonCooldown = async (
  user_id: string,
): Promise<SeonCooldownResponse> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await PrivateAdminPanelInstance.get(
    API_ROUTES.GET_SEON_COOLDOWN.replace("{user_id}", user_id),
  );

  return response?.data ?? null;
};

export const useGetSeonCooldown = (user_id?: string | null) =>
  useQuery<SeonCooldownResponse, Error>({
    queryKey: ["seonCooldown", user_id],
    queryFn: () => fetchSeonCooldown(user_id as string),
    enabled: Boolean(user_id),
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
